import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserDetails } from './services/User_service';
import { setUser } from './userSlice';
import { getEmailCountByCurrentMonth } from './services/Mail_service';
export const fetchUserDetails = createAsyncThunk(
  'user/fetchDetails',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const user = await getUserDetails();
      // console.log("📊 User données brutes du backend:", user);

      if (user) {
        let emailSentCount = 0;

        if (user.email) {
          const emailSent = await getEmailCountByCurrentMonth({ email: user.email });
          emailSentCount = emailSent?.emailCount || 0;
        } else {
          console.warn("Email utilisateur manquant, pas de comptage d'emails");
        }

        // Mapper solde_remise vers soldeRemise si nécessaire
        const userData = {
          ...user,
          email_sent_number: emailSentCount,
          soldeRemise: user.soldeRemise || 0
        };

        // console.log("💾 Utilisateur stocké en Redux avec soldeRemise:", userData.soldeRemise);
        dispatch(setUser(userData));
      }

      return user;
    } catch (error: any) {
      const message = error?.message || "Erreur inconnue";
      return rejectWithValue(message);
    }
  }
);


